import React from "react";
import Marquee from "react-fast-marquee";
import { Users, Award, Zap, Phone, Globe, ShieldCheck } from "lucide-react";
import { MARQUEE_ITEMS } from "../lib/constants";

const ICON_MAP = { Users, Award, Zap, Phone, Globe, ShieldCheck };

export default function MarqueeStrip() {
  return (
    <section
      data-testid="marquee-strip"
      className="theme-marquee py-5 overflow-hidden relative"
    >
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#000000] to-transparent z-10" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#000000] to-transparent z-10" />

      <Marquee gradient={false} speed={45} pauseOnHover>
        {MARQUEE_ITEMS.concat(MARQUEE_ITEMS).map((item, i) => {
          const Icon = ICON_MAP[item.icon] || Users;
          return (
            <div key={i} className="flex items-center gap-3 mx-10">
              <Icon className="w-5 h-5 text-[#00C2FF]" />
              <span className="font-display text-sm md:text-base theme-heading tracking-wide">
                {item.text}
              </span>
              <span className="ml-10 text-slate-300 dark:text-white/20">/</span>
            </div>
          );
        })}
      </Marquee>
    </section>
  );
}
